import { SchemaType, VariableSchema } from "../../environmentVariables/model/VariableSchema";
import { Utilities } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { rebuildVariableScopesAndTriggerValidationAction } from "./ValidateProcess";

export function addNewEnvironmentVariable(type: SchemaType, name: string, parentName: string, value: string | boolean | string[] | undefined) {
    return async (dispatch: any) => {
        try {
            await Utilities.postJsonAndParseResponse("api/environmentVariable/addSchemaWithValue", {
                parentVariableName: parentName,
                name: name,
                type: type,
                value: value
            });

            const fullName = parentName ? parentName + "." + name : name;
            dispatch(addedNewEnvironmentVariable(fullName));
            dispatch(rebuildVariableScopesAndTriggerValidationAction());

        } catch (error) {
            Utilities.toastError(error);
        }
    };
}

export const ADDED_ENVIRONMENT_VARIABLE = "ADDED_ENVIRONMENT_VARIABLE";
export function addedNewEnvironmentVariable(name: string): AddedNewEnvironmentVariableAction {
    return {
        type: ADDED_ENVIRONMENT_VARIABLE,
        environmentVariableName: name
    };
}

export interface AddedNewEnvironmentVariableAction extends IAction {
    environmentVariableName: string;
}
